import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CreateItemIcon from '@material-ui/icons/Add'
import EditItemIcon from '@material-ui/icons/Ballot'
import DeleteItemIcon from '@material-ui/icons/DeleteForever'

import PaperBlock from "../../ui/PaperBlock"

/**
 * 	<ControlPanel
 * 		selected
 *      onAddBoxClick = {}
 *      onEditBoxClick = {}
 *      onDeleteBoxClick = {}
 * 	/>
 */

class ControlPanel extends Component {

	render() {

		return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Добавить"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onAddBoxClick === "function") {
							this.props.onAddBoxClick()
						}
					}}
				>
					<CreateItemIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Редактировать"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditBoxClick === "function") {
							this.props.onEditBoxClick(this.props.selected)
						}
					}}
				>
					<EditItemIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Удалить"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteBoxClick === "function") {
							this.props.onDeleteBoxClick(this.props.selected)
						}
					}}
				>
					<DeleteItemIcon />
				</Button>
			</div></Tooltip>

		</PaperBlock>

	}

}

export default ControlPanel